import React from "react";
import styled from "styled-components";

const SeverityAlert = ({
  children,
  severity = "ok",
  variant = "block",
  className,
  ...props
}) => {
  if (variant === "row") {
    return (
      <SeverityAlertRow
        severity={severity}
        className={className}
        {...props}
      >
        {children}
      </SeverityAlertRow>
    );
  }

  return (
    <SeverityAlertBlock
      severity={severity}
      className={className}
      {...props}
    >
      {children}
    </SeverityAlertBlock>
  );
};

const getSeverityStyles = (severity) => {
  switch (severity) {
    case "high":
      return {
        color: "#e51b1d",
        backgroundColor: "#fff2f2"
      };
    case "medium":
      return {
        color: "#fda005",
        backgroundColor: "#ffeecc"
      };
    case "low":
      return {
        color: "darkgrey",
        backgroundColor: "#e6e5e3"
      };
    case "ok":
    default:
      return {
        color: "#2e7d32",
        backgroundColor: "#eeffed"
      };
  }
};

const SeverityAlertBlock = styled.div`
  display: inline-block;
  width: 100%;
  padding: 8px 12px;
  text-align: center;
  border-radius: 8px;
  border: 1px solid #e5e5ea;
  box-shadow:
    rgba(0, 0, 0, 0.1) 0px 0px 5px 0px,
    rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;
  font-weight: 500;
  transition: all 0.2s ease;

  ${({ severity }) => {
    const styles = getSeverityStyles(severity);
    return `
      color: ${styles.color};
      background-color: ${styles.backgroundColor};
    `;
  }}

  &:hover {
    transform: translateY(-1px);
    box-shadow:
      rgba(0, 0, 0, 0.15) 0px 2px 8px 0px,
      rgba(0, 0, 0, 0.1) 0px 0px 2px 0px;
  }
`;

const SeverityAlertRow = styled.div`
  width: 100%;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #e5e5ea;
  box-shadow:
    rgba(0, 0, 0, 0.1) 0px 0px 5px 0px,
    rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;
  font-weight: 500;
  transition: all 0.2s ease;

  ${({ severity }) => {
    const styles = getSeverityStyles(severity);
    return `
      color: ${styles.color};
      background-color: ${styles.backgroundColor};
    `;
  }}

  &:hover {
    transform: translateY(-1px);
    box-shadow:
      rgba(0, 0, 0, 0.15) 0px 2px 8px 0px,
      rgba(0, 0, 0, 0.1) 0px 0px 2px 0px;
  }
`;

export default SeverityAlert;
